				import worker, * as OTHER_EXPORTS from "/Users/dmitry/Projects/OneTeamSoftware/TypeScript/packages/CacheHub/packages/cloudflare-cache/test-server/index.ts";
				import * as __MIDDLEWARE_0__ from "/usr/local/lib/node_modules/wrangler/templates/middleware/middleware-ensure-req-body-drained.ts";

				export * from "/Users/dmitry/Projects/OneTeamSoftware/TypeScript/packages/CacheHub/packages/cloudflare-cache/test-server/index.ts";

				export const __INTERNAL_WRANGLER_MIDDLEWARE__ = [
					
					__MIDDLEWARE_0__.default
				]
				export default worker;